import process from '@/components/process/process';
import processRecord from '@/components/process/processRecord';
import picker from '@/components/picker/picker';
import uploader from '@/components/upload/uploader';
import editor from '@/components/editor/editor';
import vCharts from 'vue-echarts';
import btnConfirm from '@/components/confirm/btnConfirm';
import popModal from '@/components/popModal/popModal';
import FormModel from "@/components/form/FormModel";

const components = {
	install(Vue) {
		Vue.component('process', process);
		Vue.component('processRecord', processRecord);
		Vue.component('picker', picker);
		Vue.component('uploader', uploader);
		Vue.component('editor', editor);
		Vue.component('vCharts', vCharts);
		Vue.component('btnConfirm', btnConfirm);
		Vue.component('popModal', popModal);
		Vue.component('formModal', FormModel);
	}
}
export default components;